export const EVENT_PROFILE_WATCHDOG_RULE_UPDATE = 'profileWatchdogRule.update'
